import { render, staticRenderFns } from "./CopyrightAssignmentTransferFormFiles.vue?vue&type=template&id=4ae3473a&scoped=true&"
import script from "./CopyrightAssignmentTransferFormFiles.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTransferFormFiles.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAssignmentTransferFormFiles.vue?vue&type=style&index=0&id=4ae3473a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae3473a",
  null
  
)

export default component.exports